import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M6.03906 8.1051V8.9751H8.48406V6.5376H7.61406C6.74406 6.5376 6.03906 7.2426 6.03906 8.1051Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M6.03906 10.8949C6.03906 11.7574 6.74406 12.4624 7.60656 12.4624H8.47656V10.0249H6.03906V10.8949Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M9.52344 12.4624H10.3934C11.2559 12.4624 11.9609 11.7574 11.9609 10.8949V10.0249H9.52344V12.4624Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M12.1425 2H5.8575C3.1275 2 1.5 3.6275 1.5 6.3575V12.635C1.5 15.3725 3.1275 17 5.8575 17H12.135C14.865 17 16.4925 15.3725 16.4925 12.6425V6.3575C16.5 3.6275 14.8725 2 12.1425 2ZM13.0125 10.895C13.0125 12.335 11.835 13.5125 10.395 13.5125H7.605C6.165 13.5125 4.9875 12.3425 4.9875 10.895V8.105C4.9875 6.665 6.165 5.4875 7.605 5.4875H10.395C11.835 5.4875 13.0125 6.6575 13.0125 8.105V10.895Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M10.3934 6.5376H9.52344V8.9826H11.9684V8.1126C11.9609 7.2426 11.2559 6.5376 10.3934 6.5376Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_6)
  ]))
}
}

})